var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow && !_vm.isHasUserCoupon ),expression:"isShow && !isHasUserCoupon "}],staticClass:"ModalCollect"})
}
var staticRenderFns = []

export { render, staticRenderFns }